(function ($) {
    var formInputs = 'input:not([type=hidden], [type=checkbox], [type=radio]), textarea';
    var hiddenInputs = 'input[type=hidden]';
    var videoId = [];
    var a14target = "";
    var a14TargetElem = "";
    $(document).ready(function () {
        bindEvents();
        wrapInputs();
        prepRequiredFields();
        modalFormReset();

        var textareaData = $('.ContactFormChemicals .encode-multiline');
        if (textareaData !== undefined) {
            // Get the values from data attributes
            var maxLength = parseInt(textareaData.data('val-length-max'));
            if (!isNaN(maxLength)) {
                var newMaxLength = Math.floor(maxLength / 5);
                var originalMessage = textareaData.data('val-length');
                if (originalMessage !== undefined) {
                    var newMessageLength = originalMessage.replace(maxLength.toString(), newMaxLength.toString());
                    textareaData.attr('data-val-length', newMessageLength);
                }
            }
        }
    });
    // for quick link component 
    $(".commitmentBoxes").hover(function () {
        $(this).parent().parent().toggleClass("commitmenthover-item");
    });
    // close autocomple and multiselect dropdown on clickoutside
    $(document).click(function (e) {
        $('.dropdown.multiselect')
            .not($('.dropdown.multiselect').has($(e.target)))
            .children('.dropdown-content')
            .removeClass('show');
    });

    $(document).click(function (e) {
        $('.dropdown.autocomplete')
            .not($('.dropdown.autocomplete').has($(e.target)))
            .children('.dropdown-content')
            .removeClass('show');
    });

    // we chat popup in left floating bar

    $(function () {
        var left_right_margin = -$('.floating-bar').height() / 2,
            top_bottom_margin = -$('.floating-bar').width() / 2;

        $('.floating-bar-right,.floating-bar-left').css({
            'margin-top': left_right_margin
        });

        $('.floating-bar-top,.floating-bar-bottom').css({
            'margin-left': top_bottom_margin
        });
    });

    $('.follow-wechat-section').click(function (e) {
        $('.wechat-light-box').hide();
        var target = $(this).attr('data-bs-target');
        $('#' + target).show();
        return;
    });

    $(".wechat-light-box .close-button").click(function (e) {
        var id = $(this).parent().attr('id');
        $('#' + id).hide();
        e.stopPropagation();
    });

    // anchor navigation active option 
    $(function () {
        $('.Anchor-Navigation .handle').on('mouseover', function (e) {
            $('#wechat-light-box').hide();
            $('#qrBox').hide();
            $(this).addClass('active');
            e.stopPropagation();
        });

        $('.Anchor-Navigation .handle').on('mouseleave', function (e) {
            var el = $(this);
            setTimeout(function () {
                if (!$(".Anchor-Navigation .handle:hover").length && !$(".Anchor-Navigation .handle ul:hover").length) {
                    el.removeClass('active');
                }
            }, 500);
            e.stopPropagation();
        });

        $('.Anchor-Navigation ul').on('mouseleave', function () {
            $(this).parent('.handle').removeClass('active');
            if ($('.Anchor-Navigation ul').css('display') === 'none') {
                $('.Anchor-Navigation li').removeClass('active');
            }
        });

        $('.Anchor-Navigation li').on('click', function () {
            $(this).addClass('active');
            $(this).siblings().removeClass('active');
        });
    });

    //contact us GTM 
    var errorlst = "";
    var SitecoreContactID = "";
    $(document).ready(function () {
        document.addEventListener('readystatechange', function (event) {
            if (event.target.readyState === "complete") {
                decodeTextareaValue($(".ContactFormChemicals textarea[data-sc-field-name=description]"));
            }
        });

    });
    $(document).on('click', '.ContactFormChemicals .PrimaryButtonID', function () {
        if ($(".dropdown").hasClass("country-field")) {
            var countryData = $('.country-field input').attr("id");
            var countryDropDown = $('.country-field .dropdown-content').attr("id");
            checkValidSearch(countryData, countryDropDown);
        }
        if ($(".ContactFormChemicals").find("input,textarea,select").valid()) {
            var ContactFormData = $('.ContactFormChemicals .encode-multiline');
            if (ContactFormData !== undefined) {
                var multiLineLengthval = ContactFormData.val().length;
                var maxcharLength = Math.floor(ContactFormData.attr("data-val-length-max") / 5);
                if (multiLineLengthval !== undefined && !isNaN(maxcharLength)) {
                    if (multiLineLengthval <= maxcharLength) {
                        encodeTextareaValue(ContactFormData);
                        ContactFormData.css("display", "none");
                        attachEventHandler(".component.sitecore-form", "OnChemicalsFormSuccessfulSubmit", SitecoreContactID);
                    }
                    else {
                        encodeTextareaValue(ContactFormData);
                        ContactFormData.css("color", "transparent");
                        setTimeout(checkMsgLength, 100);
                    }
                }
            }
        }
        else {
            attachEventHandler(".component.sitecore-form", "invalidForm", SitecoreContactID);
        }
        // to check invalid value for other product of interest - CE 6558
        if ($(".multiselect .dropbtn").length > 0) {
            multiselectDropdownCheck();
        }
    });

    function GTMEventTriggerOnFailure() {
        //set GTM on validation failure

        errorlst = "";
        $('.field-validation-error').each(function (index) {
            var errorMsgFor = $(this).attr("data-valmsg-for");
            var errorMsgField = $(".sitecore-form input[name='" + errorMsgFor + "'], textarea[name='" + errorMsgFor + "'], select[name='" + errorMsgFor + "']");
            if (errorlst.indexOf($(errorMsgField).attr("data-sc-field-name")) == -1 && (typeof $(errorMsgField).attr("data-sc-field-name") !== "undefined")) {
                errorlst = errorlst + "|" + $(errorMsgField).attr("data-sc-field-name");
            }
        });
        //remove the first "|"
        errorlst = errorlst.substring(1);
        if (typeof errorlst === "undefined") {
            errorlst = "";
        }
        if (gtmEventErrorKey === undefined && gtmEventErrorKey.length <= 0)
            gtmEventErrorKey = "customer_support_field_errors";

        var FieldError = {
            'eventLabel': errorlst
        };
        FieldError[gtmEventErrorKey] = errorlst;
        var GTMFailureContact = GTMFailureContactUS();
        var GTMOnFailure = $.extend(GTMFailureContact, FieldError);
        dataLayer.push(GTMOnFailure);
    }

    // function GTMEventTriggerOnSuccess(UpdatedSitecoreID) {
    //     var ContactUsGTM = GTMForContactUS(UpdatedSitecoreID);
    //     dataLayer.push(ContactUsGTM);
    // }

    function checkMsgLength() {
        // Your code or function to be invoked after 2 seconds
        decodeTextareaValue($(".ContactFormChemicals .encode-multiline"));
        $(".ContactFormChemicals .encode-multiline").css("color", "");
    }

    function checkshareformMsgLength() {
        // Your code or function to be invoked after 2 seconds
        var siteCoreFormData = $(".sitecore-form .encode-multiline");
        if (siteCoreFormData !== undefined) {
            siteCoreFormData.css("display", "block");
            siteCoreFormData.css("color", "transparent");
            decodeTextareaValue(siteCoreFormData);
            siteCoreFormData.css("color", "");
            // Get the values from data attributes
            var maxShareLength = parseInt(siteCoreFormData.data('val-length-max'));
            if (!isNaN(maxShareLength)) {
                var originalShareMessage = siteCoreFormData.next().text();
                if (originalShareMessage !== undefined) {
                    var newShareMaxLength = Math.floor(maxShareLength / 5);
                    var newShareMessageLength = originalShareMessage.replace(maxShareLength.toString(), newShareMaxLength.toString());
                    siteCoreFormData.next().text(newShareMessageLength);
                }
            }
        }
    }

    // changes S-31 surface item 
    $(function () {
        $('.surfaced-item-with-bgcolor').each(function () {
            var showMoreBtn,
                text,
                mask,
                expandBtn,
                collapseBtn;
            showMoreBtn = $(this).find('.truncate-btn');
            text = $(this).find('.surfaced-item-description');
            mask = $(this).find('.mask-gradient');
            expandBtn = $(this).find('.expand-btn');
            collapseBtn = $(this).find('.collapse-btn');
            if (showMoreBtn.length > 0) {
                if ($(window).width() < 480 && $(text).height() > 73) {
                    if ($(showMoreBtn).is(':empty')) {
                        $(text).css("height", 'auto');
                    }
                    else {
                        $(text).css("height", 65);
                    }
                    $(collapseBtn).css("display", "none");
                    $(expandBtn).on('click', function () {
                        $(text).css("height", 'auto');
                        $(mask).css("display", "none");
                        $(collapseBtn).css("display", "inline-block");
                        $(expandBtn).css("display", "none");
                    });
                    $(collapseBtn).on('click', function () {
                        $(text).css("height", 65);
                        $(mask).css("display", "block");
                        $(collapseBtn).css("display", "none");
                        $(expandBtn).css("display", "inline-block");
                    });
                } else if ($(text).height() === 65) {
                    return;
                } else {
                    $(showMoreBtn).css("display", "none");
                    $(mask).css("display", "none");
                }
            }
        });
    });



    function wrapInputs() {
        var radioChecks = $(".sitecore-form").find(".checkboxes label, .radio-buttons label");
        radioChecks.unwrap(".form-group").wrap("<div class='form-group'></div>");

        // Issue 1.16 Radio buttons are not combined in a group semantically issue.
        //commented as part of 10451 changes

        // var radioButtons = $('.form-radio-container');
        // $.each(radioButtons, function (index) {
        //     var label = $(radioButtons[index]);
        //     if ($(label).length > 0) {
        //         var labelAttr = $(label).attr("data-arialabel-text");
        //         if (labelAttr) {
        //             $(label).parent().eq(0).attr("role", "radiogroup").attr("aria-labelledby", labelAttr);
        //         }
        //     }
        // });

        $('.radio-buttons').each(function () {
            $(this).attr("role", "radiogroup");
            if ($(this).find('.labelRadioText').length > 0) {
                var completeLabelText = $($(this).find('.labelRadioText')[0]).text().trim();

                var ariaLabelText = completeLabelText.substring(0, completeLabelText.length - 1);

                $(this).attr("aria-label", ariaLabelText);
            }
        });

    }
    function wrapInlineInputs() {
        var radioChecks = $(".sitecore-form").find(".checkboxes.form-inline label, .radio-buttons label");
        radioChecks.unwrap(".form-group").wrap("<div class='form-group'></div>");

        // Issue 1.16 Radio buttons are not combined in a group semantically issue.
        //commented as part of 10451 changes

        // var radioButtons = $('.form-radio-container');
        // $.each(radioButtons, function (index) {
        //     var label = $(radioButtons[index]);
        //     if ($(label).length > 0) {
        //         var labelAttr = $(label).attr("data-arialabel-text");
        //         if (labelAttr) {
        //             $(label).parent().eq(0).attr("role", "radiogroup").attr("aria-labelledby", labelAttr);
        //         }
        //     }
        // });

        $('.radio-buttons').each(function () {
            $(this).attr("role", "radiogroup");
            if ($(this).find('.labelRadioText').length > 0) {
                var completeLabelText = $($(this).find('.labelRadioText')[0]).text().trim();
                var ariaLabelText = completeLabelText.substring(0, completeLabelText.length - 1);
                $(this).attr("aria-label", ariaLabelText);
            }
        });
    }

    function prepRequiredFields() {
        $('.sitecore-form label').each(function () {
            if ($(this).text().indexOf('*')) {
                var elhtml = $(this).html();
                var ehtml = elhtml.replace(/\*/g, '<span class="wep2-required">*</span>');
                $(this).html(ehtml);
            }
        });
    }

    function modalFormReset() {
        $(".modal button.btn-close, .modal-dialog .form-cancel").off("click.form.close").on("click.form.close", function () {
            resetActiveForm($(this).closest(".modal").find("form"));
        });

        $('body').off('click.form.close').on('click.form.close', '.form-btn-close', function () {
            resetActiveForm($(this).closest("form"));
        });

        $('.pds-share-link').on('click', function () {

            resetForm();
            $(".hdn-form-btn-close").click();
        });


        $(document).ready(function() {
            if ($('.cta-callout form').length > 0) {
                resetCtaCalloutForms();
            }
        });

        // Handle browser back/forward navigation (including redirect without reload)
        window.addEventListener('pageshow', function (event) {
            if ((event.persisted || (performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0]?.type === 'back_forward')) && $('.cta-callout form').length > 0) {
                resetCtaCalloutForms();
                resetForm();
            }
        });

        $('.cta-callout').off('click.form.close').on('click.form.close', '.form-btn-close', function () {
            resetForm();
            const ctaform = $(this).closest('.cta-callout').find('form');
            
            if (ctaform.length && ctaform[0]) {
                ctaform[0].reset();
            }
        });
    }

    function resetCtaCalloutForms() {
        $('.cta-callout form').each(function () {
            this.reset();
        });
    }
    
    function resetActiveForm(activeForm) {
        if (activeForm.length) {
            resetForm();
            $(activeForm).find(".hdn-form-btn-close").click();
        }
    }
    function resetForm() {
        var forms = $('.xom-form');
        for (var i = 0; i < forms.length; i++) {
            var formId = '#' + $(forms[i]).attr('id');
            if (formId) {
                var form = $(formId);
                if (form) {
                    var validator = form.validate();
                    if (validator) {
                        validator.resetForm();
                    }
                    $(formId + " .input-validation-error").addClass("valid");
                    $(formId + " .input-validation-error").removeClass("input-validation-error");
                    $(formId + " .field-validation-error").addClass("field-validation-valid");
                    $(formId + " .field-validation-valid").removeClass("field-validation-error");
                    $(formId + " .field-validation-valid").text('');
                    $(".field-validation-valid").text('');
                }
            }
        }
    }


    $('body').on('click', '.sfmc-form-databind',
        function () {
            prepRequiredFields();
        }
    );

    $('body').on('click', '.btn-remind-ps',
        function () {
            prepRequiredFields();
        }
    );

    $('body').on('click', '.field-description',
        function (e) {
            a14TargetElem = e.target;
            a14target = ".resource-list-description a:not([data-bs-toggle*=modal])";
        });

    $('body').on('click', '.field-linktext',
        function (e) {
            a14TargetElem = e.target;
            a14target = ".resource-list-action a:not([data-bs-toggle*=modal])";
        });

    function resetValidationOnFieldsUnderNotSelectedRadioGroup() {
        /* PSWEP-2170, 2645, 2680
           inputs indicating if a certain field is required (under Business / Customer) need to have the "disabled" attribute removed before submitting the form
           they get disabled when switching between radio buttons for dropdowns related to not selected radio button
           otherwise they are validated on sitecore side as required, even though they pass the client side validation
           and that causes the form to reload with a required message next to that field under the not chosen radio group
           it cannot be handled when switching between radios as sometimes the disabled attribute either reappeared or not disappeared soon enough (so was still there when submitting the form)
           Since the blocking issue is with disabled hidden fields, we traverse as such
           .xom-form > all inputs that are hidden and disabled and removed the disabled attribute from those fields
       */
        var disabledFields = $('.xom-form').find('input[type="hidden"][disabled]');
        $.each(disabledFields, function () {
            $(this).removeAttr("disabled");
        });

        /* PSWEP-2680 (in comments)
            In case a user selects one radio, fill in some of the data under it and attempts to submit the form, client validation prevents it from being sent to server.
            It adds some error classes and set the form's isSubmittedFlag attribute to true.
            Then if user switches to the other radio and fills in all data properly on that side, the added previously classes and isSubmittedFlag still prevents the form from being submitted
            To fix it, we need to remove isSubmittedFlag and update those error classes on the fields that are under a non-displayed form-group (that is the only way to recognize fields related to the not selected radio)
        */
        $(this).find(".modal-body .sitecore-form form").removeAttr("isSubmittedFlag");

        var hiddenFormGroup = $('.form-group').filter(function () {
            return $(this).css('display') == 'none';
        });

        $.each(hiddenFormGroup, function () {
            var fieldsWithErrors = $(this).find(".input-validation-error");
            $.each(fieldsWithErrors, function () {
                $(this).addClass("valid");
                $(this).removeClass("input-validation-error");
            });

            var validationMessageFields = $(this).find(".field-validation-error");
            $.each(validationMessageFields, function () {
                $(this).addClass("field-validation-valid");
                $(this).removeClass("field-validation-error");
                $(this).text('');
            });
        });
    }

    function bindEvents() {
        var $forms = $('.sitecore-form form');
        $("form select").off("blur").on("blur", function (e) {
            setTimeout(function () {
                // Accessibility - TFS bug 83246
                if (!$("#" + e.currentTarget.id + "-error").length) {
                    $("#" + e.currentTarget.id).removeAttr("aria-describedby");
                }
                /* for(var i=0;i< $('.sitecore-form input[type="checkbox"]').length ; i++){
                     if($('.sitecore-form input[type="checkbox"]')[i].getAttribute('aria-required') === 'False' || $('.sitecore-form input[type="checkbox"]')[i].getAttribute('aria-required') === 'false') {
                         var ele = $('.sitecore-form input[type="checkbox"]')[i];
                         ele.removeAttribute("aria-describedby");
                     } else {
                         var ele2 = $('.sitecore-form input[type="checkbox"]')[i];
                         ele2.setAttribute("aria-describedby",$('.sitecore-form input[type="checkbox"]')[i].getAttribute('name'));
                     }
                 } */
                // $("select").removeAttr("aria-describedby");
            }, 1000);
        });
        setTimeout(function () {
            requestAnimationFrame(() => {
                $(".modal.fade.show .sitecore-form").find('input:visible, select:visible, textarea:visible').first().focus(); // Accessibility - TFS bug 83246
                //  $("form select").removeAttr("aria-describedby");
            });
        }, 1000);
        if ($(".modal.fade").hasClass('show')) {
            setTimeout(function () {
                // add all the elements inside modal which you want to make focusable
                var focusableElements = 'button:not(.d-none), [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
                var modalID = $(".modal.fade.show").attr("id");
                for (var i = 0; i < $('.modal.fade').length; i++) {
                    if ($('.modal.fade')[i].getAttribute('id') && !$('.modal.fade')[i].getAttribute('aria-hidden') && $(".modal.fade").hasClass('show')) {
                        modalID = $(".modal.fade")[i].getAttribute("id");
                    }
                }
                if (modalID !== undefined) {

                    document.addEventListener('keydown', function (e) {
                        var modal = document.querySelector("#" + modalID); // select the modal by it's id
                        var firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
                        var focusableContent = modal.querySelectorAll(focusableElements);
                        var lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

                        var isTabPressed = e.key === 'Tab' || e.keyCode === 9;
                        if (!isTabPressed) {
                            return;
                        }
                        if (e.shiftKey) { // if shift key pressed for shift + tab combination
                            if (document.activeElement === firstFocusableElement) {
                                lastFocusableElement.focus(); // add focus for the last focusable element
                                e.preventDefault();
                            }
                        } else { // if tab key is pressed
                            if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                                firstFocusableElement.focus(); // add focus for the first focusable element
                                e.preventDefault();
                            }
                        }
                    });
                    //firstFocusableElement.focus();
                    if ($("#" + modalID).hasClass('dr1vrs_club')) {
                        var width = $(document).width();
                        if (width >= 992) {
                            $(".modal.fade.show .sitecore-form input[type='text'].form-control").first().focus();
                        }
                    } else {
                         requestAnimationFrame(() => {
                            $(".modal.fade.show .sitecore-form").find('input:visible, select:visible, textarea:visible').first().focus(); // Accessibility - TFS bug 83246
                            //  $("form select").removeAttr("aria-describedby");
                        });
                    }
                    if ($("body").hasClass("modal-open")) {
                        $(".body-content").attr("aria-hidden", "true");
                        $("#footer").attr("aria-hidden", "true");
                    } else {
                        $(".body-content").removeAttr("aria-hidden");
                        $("#footer").removeAttr("aria-hidden");
                    }
                }
            }, 300);

        }

        $('body').on('submit', '.sitecore-form form', function (evt) {
            resetValidationOnFieldsUnderNotSelectedRadioGroup();

            //Form submit if used to bind in broader scope like body, will trigger multiple submit based on no of forms on the page
            if ($(".invalid-field").length > 0) {
                evt.preventDefault();
                evt.stopPropagation();
            } else if (!$(this).find(".form-btn-close:visible").length  || $(this).closest('.cta-callout')) {
                sanitizeFormInputs(evt);
                setTimeout(wrapInputs, 200);
            }
        });

        //Remove the attribute aria-describedby for the selectboxes inside forms
        $("body").on("click", "form [type='submit']", function () {
            //  $("form select").removeAttr("aria-describedby");
            setTimeout(function () {
                var selectBoxs = $("select[aria-describedby]");
                for (var j = 0; j < selectBoxs.length; j++) {
                    if ($(selectBoxs[j]).val() && $(selectBoxs[j]).val() !== "")
                        $(selectBoxs[j]).removeAttr("aria-describedby");
                }
            }, 1000);
        });
        //this code is to set delay timer on button, it will enable button after value specified in delay-timer button attribute
        $('body').off('shown.bs.modal').on('shown.bs.modal', '.modal', function (e) {
            $("form select").removeAttr("aria-describedby");
            $("form input").removeAttr("aria-describedby");
            $("form textarea").removeAttr("aria-describedby");
            $('.sitecore-form input[type="radio"]').removeAttr("aria-describedby");
            $('.sitecore-form input[type="checkbox"]').removeAttr("aria-describedby");
            setTimeout(wrapInputs, 200);
            $(this).find(".modal-body .sitecore-form form").attr("isSubmittedFlag", true);
            var submitButton = $(this).closest('.modal').find('.form-submit');
            if (submitButton != null && submitButton != 'undefined') {
                var isDelayEnabled = $(submitButton).attr('is-delay');
                var delayTimer = $(submitButton).attr('delay-timer');
                if (isDelayEnabled != null && delayTimer != null && isDelayEnabled != 'undefined' && delayTimer != 'undefined') {
                    $(submitButton).disabled = true;
                    $(submitButton).attr("disabled", "true");
                    setTimeout(function () { $(submitButton).disabled = false; $(submitButton).removeAttr("disabled"); }, delayTimer);
                }
            }
            bindEvents();
        });
        $('body').on('change', formInputs, resetXssCheck);



        $('.btn-close,.form-submit,.form-cancel').on('click', function () {
            $(".body-content").removeAttr("aria-hidden");
            $("#footer").removeAttr("aria-hidden");
            $(".dr1vrs_club").removeClass("success_modal");
            setTimeout(function () {
                for (var i = 0; i < $('.sitecore-form input').length; i++) {
                    if ($('.sitecore-form input')[i].getAttribute('aria-required') === 'False' || $('.sitecore-form input')[i].getAttribute('aria-required') === 'false') {
                        var ele = $('.sitecore-form input')[i];
                        ele.removeAttribute("aria-describedby");
                    }
                }
            }, 500);
            setTimeout(function () {
                for (var i = 0; i < $('.sitecore-form textarea').length; i++) {
                    if ($('.sitecore-form textarea')[i].getAttribute('aria-required') === 'False' || $('.sitecore-form textarea')[i].getAttribute('aria-required') === 'false') {
                        var ele = $('.sitecore-form textarea')[i];
                        ele.removeAttribute("aria-describedby");
                    }
                }
            }, 500);
            setTimeout(function () {
                for (var i = 0; i < $('.sitecore-form select').length; i++) {
                    if ($('.sitecore-form select')[i].getAttribute('aria-required') === 'False' || $('.sitecore-form select')[i].getAttribute('aria-required') === 'false') {
                        var ele = $('.sitecore-form select')[i];
                        ele.removeAttribute("aria-describedby");
                    }
                }
            }, 500);
            setTimeout(function () {
                for (var i = 0; i < $('.sitecore-form input[type="radio"]').length; i++) {
                    if ($('.sitecore-form input[type="radio"]')[i].getAttribute('aria-required') === 'False' || $('.sitecore-form input[type="radio"]')[i].getAttribute('aria-required') === 'false') {
                        var ele = $('.sitecore-form input[type="radio"]')[i];
                        ele.removeAttribute("aria-describedby");
                    }
                }
            }, 500);
            setTimeout(function () {
                for (var i = 0; i < $('.sitecore-form input[type="checkbox"]').length; i++) {
                    if ($('.sitecore-form input[type="checkbox"]')[i].getAttribute('aria-required') === 'False' || $('.sitecore-form input[type="checkbox"]')[i].getAttribute('aria-required') === 'false') {
                        var ele = $('.sitecore-form input[type="checkbox"]')[i];
                        ele.removeAttribute("aria-describedby");
                    }
                }
            }, 500);
        });
        // to check invalid value on mouse leave for other product of interest - CE 6558
        if ($(".multiselect .dropbtn").length > 0) {
            $(".multiselect .dropbtn").on('mouseleave', function () {
                multiselectDropdownCheck();
            });
        }
    }

    var globalAjaxRequestState = false;
    var lastSubmittedForm;
    var intervalId;
    var buttonElementText;
    var productNameInTitle;
    var angularObj;
    var isGalleryForm = false;
    var isGalleryFormSubmit = false;
    var galleryModalId;
    var isa14Form = false;
    var isa14FormSubmit = false;
    var a14formModalId;
    function sanitizeFormInputs(evt) {
        var $form = $(evt.target);
        galleryModalId = $form.attr("data-gallery-lock-id");
        if (($form.attr('data-gallery-locked-form')) == 'true') {
            isGalleryForm = true;
            isGalleryFormSubmit = true;
            var submitButtontext = $("#" + $form.attr("id") + "").find("input[type='submit']").val();
            angularObj = {
                "elementText": submitButtontext.toLowerCase() ? submitButtontext.toLowerCase() : undefined,
                "formName": getFormName($form),
                "formTitle": getFormTitle($form).toLowerCase(),
                "formDropdowns": getFormDropdowns($form),
                "parentName": getParentName($form).toLowerCase(),
                "parentTitle": getParentTitle(null, $form)
            };
        } else {
            isGalleryForm = false;
        }
        a14formModalId = $form.attr("data-a14-link-id");
        if (($form.attr('data-a14-form')) == 'true') {
            isa14Form = true;
            isa14FormSubmit = true;
        } else {
            isa14Form = false;
        }
        if ($("#" + $form.attr("id") + "").find("input:not([type='button']):visible").length) {
            lastSubmittedForm = $form.attr("id");
            productNameInTitle = $('#prodNameLabel').find('.dynamic-text:visible').text();
            var tempButtontext = $("#" + $form.attr("id") + "").find("input[type='submit']").val();
            angularObj = {
                "elementText": tempButtontext.toLowerCase() ? tempButtontext.toLowerCase() : undefined,
                "formName": getFormName($form),
                "formTitle": getFormTitle($form).toLowerCase(),
                "formDropdowns": getFormDropdowns($form),
                "parentName": getParentName($form).toLowerCase(),
                "parentTitle": getParentTitle(null, $form)
            };
            buttonElementText = angularObj.elementText.toLowerCase();
        } else {
            lastSubmittedForm = undefined;
            productNameInTitle = undefined;
        }

        if (!$form.attr('data-xss-checked')) {
            evt.preventDefault();
            evt.stopPropagation();
            var duplicatesFound = false;
            if ($form.find("[data-anti-spam-check]").length && $form.find("[data-anti-spam-check]").attr("data-anti-spam-check") === "True") {
                var availableTextFields = $(".modal-dialog form").find("input[type='text']:visible,input[type='Text']:visible,input[type='number']:visible,textarea:visible");
                var inputValuesArray = [];
                for (var i = 0; i < availableTextFields.length; i++) {
                    var tempValue = $(availableTextFields[i]).val();
                    if (tempValue.trim() !== "") {
                        inputValuesArray.push(tempValue.trim());
                    }
                }
                var uniqueValues = inputValuesArray.filter(function (el, index, arr) {
                    if (el.trim() !== "") {
                        return index === arr.indexOf(el.trim());
                    }
                });
                duplicatesFound = inputValuesArray.length !== uniqueValues.length;
            }



            if (!duplicatesFound && !$form.find('.input-validation-error').length && $form.valid()) {
                $form.attr('data-xss-checked', 'true');
                globalAjaxRequestState = true;
                if ($form.find('.form-sending').length) {
                    $('.modal.show .modal-content').append('<div class="modal-sending-backdrop"></div> ');
                    $('.modal.show').find('.modal-sending-backdrop').addClass('show');
                    $form.find('.form-sending').removeClass('d-none');
                    $form.find('.form-submit').addClass('d-none');
                }
                if ($form.find(".component.button-bar .duplicateErrorMessage").length) {
                    $form.find(".component.button-bar .duplicateErrorMessage").empty().remove();
                }
                $form.find(formInputs).each(function (i, field) {
                    if ($(field)[0].dataset.encode && $(field)[0].dataset.encode.toLowerCase() === 'true') {
                        $form.find(hiddenInputs).each(function (j, hiddenfield) {
                            var name = $(field)[0].dataset.scFieldName.toLowerCase();
                            if ($(hiddenfield)[0].dataset.scFieldName && (($(hiddenfield)[0].dataset.scFieldName.toLowerCase() === 'hdn' + name) && $(hiddenfield)[0].dataset.scFieldName.substring(3).toLowerCase() === name)) {
                                $(hiddenfield).val(encodeTextValue($(field).val()));
                                $(field).val(removeSpecialCharacters($(field).val(), [/\//, /\&/, /\-/, /\_/, /\!/, /\(/, /\)/, /\[/, /\]/, /\,/, /\;/, /\:/, /\./, /\*/, /\^/, /\~/, /\�/, /\+/, /\�/, /\"/, /\#/, /\$/, /\%/, /\=/, /\|/, /\�/, /\�/, /\'/, /\?/, /\@/, /\`/, /\{/, /\}/, /\�/, /\\/, /\&amp;/]));
                            }
                        });
                    }
                });
                $form.submit();
            }
            else if (duplicatesFound) {
                $form.find(".component.button-bar .duplicateErrorMessage").empty().remove();
                $form.find(".component.button-bar").last().prepend("<div class='text-danger duplicateErrorMessage'>" + $form.find("[data-anti-spam-message]").attr("data-anti-spam-message") + "</div>");
            }
            $form.find(formInputs).each(function (i, field) {
                $(field).val($.fn.xss.sanitize($(field).val()));
            });


            if ($form.closest('.cta-callout')) {

                Promise.all([
                    getevent1("fo", $form),
                    getEventAction("fo", "", "", $form)
                ]).then(([event1Value, eventActionValue]) => {

                    ctaFormObj = {
                        "elementText": $("#" + $form.attr("id") + "").find("input[type='submit']").val().toLowerCase(),
                        "formName": getFormName($form),
                        "formTitle": getFormTitle($form).toLowerCase(),
                        "formDropdowns": getFormDropdowns($form),
                        "parentName": getParentName($form).toLowerCase(),
                        "parentTitle": getParentTitle("fo", $form),
                        "event1": event1Value,
                        "contentTitle": getContentTitle($form),
                        "eventAction": eventActionValue,
                        "eventLabel": getEventLabel($form),
                        'document_type': getDocType($form),
                        "document_title": getGtmVal($form),
                        'customer_type_selection': customeTypeSelection($form),
                        'primary_nature_of_inquiry_selection': primaryNature($form),
                        'job_role_selection': jobRoleSelection($form),
                        'location_selection': locationSelectionVal($form),
                        'industry_selection': industrySelectionVal($form),
                        'business_type_selection': businessTypeVal($form),
                        'primary_product_of_interest_selection': primaryProductInterest($form),
                        'other_product_of_interest_selection': otherProducts($form),
                    };

                });
            }

        }
    }
    function showTickMark() {
        if ($(".icon_container").hasClass('hide_tick')) {
            $(".icon_container").removeClass("hide_tick");
            clearInterval(intervalId);
        }
    }
    $(document).ajaxSuccess(function (e, xhr, setting) {
        if (globalAjaxRequestState) {
            $('.modal.show').find('.modal-sending-backdrop').remove();


            globalAjaxRequestState = false;
        }

        wrapInlineInputs();
        if (xhr.status === 200 && xhr.responseText.indexOf("validation-summary-errors") == -1 && lastSubmittedForm && buttonElementText && $("#" + lastSubmittedForm + "")) {
            if ($('.lpg-form').length) {
                attachEventHandler(".component.sitecore-form", "OnFormSuccessfulSubmit", angularObj, $("#" + lastSubmittedForm + ""), buttonElementText);
            } else {
                attachEventHandler(".component.sitecore-form", "OnFormSuccessfulSubmit", angularObj, $("#" + lastSubmittedForm + ""), ctaFormObj);
            }

            //if (($(lastSubmittedForm).attr('data-gallery-locked-form')) == 'true') {
            //    setGalleryLockFeatureHandler(lastSubmittedForm);
            //}
            $('.form-btn-close').on('click', function () {
                $(".dr1vrs_club").removeClass("success_modal");
            });

            $(".success_anime").parents(".dr1vrs_club").addClass("success_modal");
            intervalId = setInterval(showTickMark, 500);
            // setTimeout(function () {
            //     $(".icon_container").removeClass("hide_tick");
            // }, 500);

            lastSubmittedForm = undefined;
            productNameInTitle = undefined;
            buttonElementText = undefined;
            angularObj = {};
        } else if (xhr.responseText.indexOf("validation-summary-errors") > -1) {

            clearTimeout(formTimer);
            formTimer = setTimeout(function () {
                $("#" + lastSubmittedForm + "").trigger('invalidForm');
                wrapInputs();
                if (xhr.responseText.indexOf("{prodNameLabel}") > -1) {
                    $('#prodNameLabel:visible').html(sanitizeHtmlStrings($('#prodNameLabel:visible').html().replace('{prodNameLabel}',
                        '<span class="dynamic-text">' + productNameInTitle + '</span>')));
                }
                lastSubmittedForm = undefined;
                productNameInTitle = undefined;
                buttonElementText = undefined;
                angularObj = {};
                // to keep charecter count after form submit
                if ($('.sitecore-form textarea').hasClass('character-count')) {
                    $("#charactercount").text($('.sitecore-form textarea.character-count')[0].value.length);
                }
            }, 1000);
            setTimeout(function () {
                checkshareformMsgLength();
            });
        }

        if (xhr.status === 200 && xhr.responseText.indexOf("validation-summary-errors") == -1 && isGalleryForm && isGalleryFormSubmit) {
            var formid = $(galleryModalId).find('form').attr('id');
            setGalleryLockFeatureHandler();
            attachEventHandler(".component.sitecore-form", "OnFormSuccessfulSubmit", angularObj, $("#" + formid + ""));
        }

        if (xhr.status === 200 && xhr.responseText.indexOf("validation-summary-errors") == -1 && isa14Form && isa14FormSubmit) {
            a14linkPDFDownloadHandler();
        }

        setTimeout(function () {
            if ($('.mobilsmilescheck:checked').length) {
                $(".mobilsmilescardno").parents(".form-area.form-group").show();
                $(".mobilsmilescardno").parents(".form-area.form-group").removeClass("d-none");
            }
            else {
                $(".mobilsmilescardno").parents(".form-area.form-group").hide();
                $(".mobilsmilescardno").parents(".form-area.form-group").addClass("d-none");
            }
            $('.sitecore-form form').off('invalid-form.validate');
            $('.sitecore-form form').on('invalid-form.validate', function () {
                var $form = $(this);
                // Since multiple validation events may happen based on the form config, roll them up to one event
                clearTimeout(formTimer);
                formTimer = setTimeout(function () {
                    $form.trigger('invalidForm');
                }, 1000);
            });
        }, 1000);

    });
    function resetXssCheck(evt) {
        $form = $(evt.target).removeAttr('data-xss-checked');
    }

    function setGalleryLockFeatureHandler() {
        var id = galleryModalId;
        videoId.push(id);
        isGalleryForm = false;
        isGalleryFormSubmit = false;
        sessionStorage.setItem("videoId", JSON.stringify(videoId));
        $('.gallery-inner.wep-gallery .row a.video-link-item').each(function () {
            var targetid = $(this).attr('data-bs-target');
            var targetsrc = $(this).attr('data-src');
            if (targetid == id) {
                $(targetid).attr('data-video-locked', false);
                
                // Check for video or iframe
                var mediaElement = null;
                var isVideoTag = false;
                
                if ($(targetid).find('.dfs-video') && $(targetid).find('.dfs-video').length > 0) {
                    mediaElement = $(targetid).find('.dfs-video');
                    isVideoTag = true;
                } else if ($(targetid).find('iframe') && $(targetid).find('iframe').length > 0) {
                    mediaElement = $(targetid).find('iframe');
                    isVideoTag = false;
                }
                
                if (mediaElement && mediaElement.length > 0) {
                    $(mediaElement).css('display', 'block');
                    $(targetid).find('.modal-body').css('background-color', 'transparent');
                    $(targetid).find('form').remove();
                    
                    if (isVideoTag) {
                        $(targetid).find('.dfs-video').parent().removeClass('embed-form-video');
                    } else {
                        $(targetid).find('.embed-responsive-16by9').removeClass('embed-form-iframe');
                        $(targetid).find('.embed-responsive-16by9').addClass('embed-responsive');
                    }
                    
                    var targetclass = $(this).find('.fa-lock').attr('data-video-icon-class');
                    $(this).find('.fa-lock').addClass(targetclass);
                    $(this).find('.fa-lock').removeClass('fa-2x');
                    $(this).find('.fa-lock').css('top', '50%');
                    $(this).find('.fa-lock').css('left', '50%');
                    $(this).find('.fa-lock').removeClass('fa-lock');
                    
                    if ($(mediaElement).attr('data-autoplay-enabled') === 'True') {
                        $(this).siblings().children().find('.modal-content').css('background-color', 'transparent');
                        var videosrc = $(mediaElement).attr('data-original-src');
                        addParamstoGalleryVideos(videosrc, mediaElement);
                    }
                    else {
                        $(this).siblings().children().find('.modal-content').css('background-color', 'transparent');
                        addParamstoGalleryVideos(targetsrc, mediaElement);
                    }
                }
            }
        });
    }

    function a14linkPDFDownloadHandler() {
        var targethref = $(a14formModalId).attr('data-href');

        var a14session = sessionStorage.getItem('a14formId');

        if (a14session == null) {
            var a14sessionId = [];
            a14sessionId.push(a14formModalId);
            sessionStorage.setItem("a14formId", JSON.stringify(a14sessionId));
        } else {
            a14session = JSON.parse(a14session);
            a14session.push(a14formModalId);
            sessionStorage.setItem("a14formId", JSON.stringify(a14session));
        }

        var link = document.createElement('a');
        link.setAttribute('href', sanitizeHtmlStrings(targethref));
        link.click();
        isa14Form = false;
        isa14FormSubmit = false;
        attachEventHandler(".component.a14-resource-list", a14target, angularObj, a14TargetElem);

        $('.a14-form-link').each(function () {
            var targetid = $(this).attr('data-bs-target');
            var targethref = $(this).attr('data-href');

            if (targetid == a14formModalId) {
                $(this).attr('href', targethref);
                $(this).attr('data-bs-toggle', '');
            }
        });
    }

    // LPG form changes

    $(document).ready(function () {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        today = yyyy + '-' + mm + '-' + dd;
        $('.lpg-form-slot').attr('disabled', true);
        var isToday, minDate, tommorowDate;
        if ($(".lpg-form-date").length) {
            isToday = document.querySelector(".lpg-form-date").getAttribute("data-sc-today-date-bool");
            minDate = document.querySelector(".lpg-form-date").getAttribute("min");
            var todayVal = new Date(minDate);
            var day;
            if (todayVal.getDate() == new Date(todayVal.getFullYear(), todayVal.getMonth() + 1, 0).getDate()) {
                todayVal.setMonth(todayVal.getMonth() + 1, 1);
                tommorowDate = todayVal;
                day = tommorowDate.getDate();
            } else {
                tommorowDate = new Date(minDate);
                day = tommorowDate.getDate() + 1;
            }
            //   var day = tommorowDate.getDate() + 1;
            var month = tommorowDate.getMonth() + 1;
            var year = tommorowDate.getFullYear();
            if (!$('.lpg-form-date').val()) {
                $('.lpg-form-slot').attr('disabled', true);
            } else {
                $('.lpg-form-slot').removeAttr('disabled');
            }
            if (day < 10) {
                day = '0' + day;
            }
            if (month < 10) {
                month = '0' + month;
            }
            tommorowDate = year + '-' + month + '-' + day;
            initializeLPGFormData();
        }
        function initializeLPGFormData() {
            if (isToday.toLowerCase() !== 'true') {
                document.querySelector(".lpg-form-date").min = tommorowDate;
            }

        }
        function handler() {
            $('.lpg-form-slot').removeAttr('disabled');
            var todayTime = document.querySelector(".lpg-form-date").getAttribute("data-sc-time-in-hour");
            var getAMPM = document.querySelector(".lpg-form-date").getAttribute("data-sc-time-in-designator");
            if (getAMPM == 'PM' && todayTime < 12) {
                todayTime = parseInt(todayTime) + 12;
            } else if (getAMPM == 'AM' && todayTime == 12) {
                todayTime = parseInt(todayTime) - 12;
            }
            var dataInput = document.querySelector(".lpg-form-date");
            var currentDate = dataInput.value;
            var todayDate = new Date();
            var nextDate = new Date(currentDate);
            var diff_in_days = (nextDate.getTime() - todayDate.getTime()) / (1000 * 60 * 60 * 24);
            if (currentDate == today) {
                currentTime();
            }
            else if (currentDate > today && diff_in_days <= 1 && isToday.toLowerCase() !== 'true') {
                currentTime();
            } else if (currentDate > today && diff_in_days > 1) {
                $(".lpg-form-slot").children().removeAttr("disabled");
            }
            function currentTime() {
                var counter = 0;
                $(".lpg-form-slot").children().each(function () {
                    var strOpt = $(this).attr("value");
                    var timeSplit = strOpt.split("-");
                    startTime = timeSplit[0].trim();
                    //endTime = timeSplit[0].trim();

                    var checkAmPm = startTime.replace(/\d+/g, '');

                    var hours = startTime.replace(checkAmPm, "");

                    if (checkAmPm == "PM" && hours < 12) hours = parseInt(hours) + 12;
                    if (checkAmPm == "AM" && hours == 12) hours = parseInt(hours) - 12;
                    if (hours < 10) {
                        hours = '0' + hours;
                    }
                    if (todayTime >= hours) {
                        $(this).prop("disabled", "true");

                    } else {
                        counter++;
                    }
                });
                if (counter === 0) {
                    document.querySelector(".lpg-form-date").value = tommorowDate;
                    $(".lpg-form-slot").children().removeAttr("disabled");
                }


            }
        }

        $(".lpg-form-date").change(function () {
            handler();
        });
    });

    // removing aria-described for input fields with errors even for valid input
    $(document).ready(function () {
        function removedAriaAttribute(e) {
            setTimeout(function () {
                if (e.currentTarget.id) {
                    if (!$("#" + e.currentTarget.id + "-error").length) {
                        $("#" + e.currentTarget.id).removeAttr("aria-describedby");
                    }
                }

            }, 500);
        }
        $('.sitecore-form input').focusout(function (e) {
            if ($(e.currentTarget).attr("type") && $(e.currentTarget).attr("type").toLowerCase() !== "checkbox" && $(e.currentTarget).attr("type").toLowerCase() !== "radio") {
                removedAriaAttribute(e);
            }
        });

        $('.sitecore-form input').focusin(function (e) {
            if ($(e.currentTarget).attr("type") && $(e.currentTarget).attr("type").toLowerCase() !== "checkbox" && $(e.currentTarget).attr("type").toLowerCase() !== "radio") {
                removedAriaAttribute(e);
            }
        });

        $('.sitecore-form input').focus(function (e) {
            if ($(e.currentTarget).attr("type") && $(e.currentTarget).attr("type").toLowerCase() !== "checkbox" && $(e.currentTarget).attr("type").toLowerCase() !== "radio") {
                removedAriaAttribute(e);
            }
        });
        $('.sitecore-form input').on('keypress keyup keydown', function (e) {
            if ($(e.currentTarget).attr("type") && $(e.currentTarget).attr("type").toLowerCase() !== "checkbox" && $(e.currentTarget).attr("type").toLowerCase() !== "radio") {
                removedAriaAttribute(e);
            }
        });


        $('.sitecore-form textarea').focusout(function (e) {
            removedAriaAttribute(e);
        });

        $('.sitecore-form textarea').focusin(function (e) {
            removedAriaAttribute(e);
        });

        $('.sitecore-form textarea').focus(function (e) {
            removedAriaAttribute(e);
        });
        $('.sitecore-form textarea').change(function (e) {
            removedAriaAttribute(e);
        });
        $('.sitecore-form textarea').on('keypress keyup keydown', function (e) {
            removedAriaAttribute(e);
        });

        $('.sitecore-form select').focusout(function (e) {
            removedAriaAttribute(e);
        });

        $('.sitecore-form select').focusin(function (e) {
            removedAriaAttribute(e);
        });

        $('.sitecore-form select').focus(function (e) {
            removedAriaAttribute(e);
        });
        $('.sitecore-form select').change(function (e) {
            removedAriaAttribute(e);
        });

        function removedAriaAttributeForRadio(e) {
            setTimeout(function () {
                for (var i = 0; i < $('.sitecore-form input[type="radio"]').length; i++) {
                    if (e.target.name === $('.sitecore-form input[type="radio"]')[i].name && $('.sitecore-form input[type="radio"]')[i].className === 'valid') {
                        var ele = $('.sitecore-form input[type="radio"]')[i];
                        ele.removeAttribute("aria-describedby");
                    } else {
                        if (e.target.name === $('.sitecore-form input[type="radio"]')[i].name && $('.sitecore-form input[type="radio"]')[i].className === 'input-validation-error') {
                            var ele2 = $('.sitecore-form input[type="radio"]')[i];
                            ele2.setAttribute("aria-describedby", $('.sitecore-form input[type="radio"]')[i].name + '-error');
                        }
                    }
                }
            }, 500);
        }
        function removedAriaAttributeForCheckbox(e) {
            setTimeout(function () {
                for (var i = 0; i < $('.sitecore-form input[type="checkbox"]').length; i++) {
                    if (e.target.name === $('.sitecore-form input[type="checkbox"]')[i].name && $('.sitecore-form input[type="checkbox"]')[i].className === 'valid') {
                        var ele = $('.sitecore-form input[type="checkbox"]')[i];
                        ele.removeAttribute("aria-describedby");
                    } else {
                        if ((e.target.name === $('.sitecore-form input[type="checkbox"]')[i].name && $('.sitecore-form input[type="checkbox"]')[i].className === 'input-validation-error')) {
                            var ele2 = $('.sitecore-form input[type="checkbox"]')[i];
                            ele2.setAttribute("aria-describedby", $('.sitecore-form input[type="checkbox"]')[i].name + '-error');
                        }
                    }
                }
            }, 1000);
        }


        $('body').click('.sitecore-form input[type="radio"]', function (e) {
            removedAriaAttributeForRadio(e);
        });


        $('body').click('.sitecore-form input[type="checkbox"]', function (e) {
            removedAriaAttributeForCheckbox(e);
        });


        $('body .sitecore-form input[type="checkbox"]').focus(function (e) {
            removedAriaAttributeForCheckbox(e);
        });

        $('body .sitecore-form input[type="radio"]').focus(function (e) {
            removedAriaAttributeForRadio(e);
        });
    });

    function encodeTextValue(inputTxt) {
        var formattedTxt = "";

        var i = 0;
        while (i < inputTxt.length) {
            if (inputTxt[i] == " " || inputTxt[i] == "\r" || inputTxt[i] == "\n" || inputTxt[i] == "\r\n") {
                formattedTxt += inputTxt[i];
                i++;
            } else {
                var chr = inputTxt.charCodeAt(i++);
                if (chr >= 0xD800 && chr <= 0xDBFF) {
                    // surrogate pair
                    var low = inputTxt.charCodeAt(i++);
                    formattedTxt += ("0000000" + (0x10000 + ((chr - 0xD800) << 10) | (low - 0xDC00)).toString(16)).substr(-8);
                } else {
                    // ordinary character
                    formattedTxt += ("0000000" + chr.toString(16)).substr(-8);
                }
            }
        }
        return formattedTxt;
    }
    function multiselectDropdownCheck() {
        if ($(".multiselect .dropdown-content").length > 0) {
            var dlen = $(".multiselect .dropdown-content").find("label").length;
            var arrDropDown = [];
            for (var k = 1; k < dlen; k++) {
                var checkVal = $(".multiselect .dropdown-content").find("label input")[k].checked;
                if (checkVal) {
                    var valdata = $(".multiselect .dropdown-content").find("label input")[k].value;
                    arrDropDown.push(valdata);
                }
            }
            var newval = arrDropDown.join(", ");
            $(".multiselect .dropbtn").val(newval);
        }
    }
    function removeSpecialCharacters(retStr, replace) {
        for (var i = 0; i < replace.length; i++) {
            retStr = retStr.replace(new RegExp(replace[i], 'g'), '');
        }
        return retStr;
    }
}(window.jQuery));

(function () {
    $(document).ready(function () {
        init();

        function init() {
            var dynamicText = '{prodNameLabel}';
            var headingElement = $('[pds-heading]');

            $('body').on('click',
                '.pds-share-link, .quick-links [data-bs-target]',
                function (e) {
                    var pageTitle = '',
                        screenTitleElement = $('.special-screen-title .special-screen-title-text .field-title'),
                        a04ScreenTitleElement = $('.a04-special-screen-title .special-screen-title-text .field-title'),
                        dataSheetElement = $(this).closest('.modal-body').find('.pull-left h3');
                    var headingText = '';
                    if ($(this).attr('document-type') != 'undefined') {
                        var pdsSdsType = $(this).attr('document-type');

                        if (pdsSdsType === 'pds') {
                            headingText = ' ' + document.getElementById("h6ProductNamePDS").getAttribute("data-pds-heading");
                        }
                    }
                    if (typeof (screenTitleElement) !== 'undefined' && screenTitleElement.length > 0) {
                        pageTitle = screenTitleElement.text();
                    }
                    else if (typeof (a04ScreenTitleElement) !== 'undefined' && a04ScreenTitleElement.length > 0) {
                        pageTitle = a04ScreenTitleElement.text();
                    }
                    else if (typeof (dataSheetElement) !== 'undefined' && dataSheetElement.length > 0) {
                        pageTitle = dataSheetElement.text() + headingText;
                    } else if (typeof (headingElement) !== "undefined" && headingElement.length > 0) {
                        pageTitle = $(headingElement).attr('pds-heading');
                    }
                    if (pageTitle == 'undefined' || pageTitle == '') {
                        pageTitle = document.title != '' ? document.title : '';
                    }

                    var id = e.currentTarget.dataset.bsTarget;
                    var targetId = $(e.currentTarget.dataset.bsTarget).find('#prodNameLabel');
                    var headingHtml = $(e.currentTarget.dataset.bsTarget).find('#prodNameLabel').html();
                    if (headingHtml && headingHtml.indexOf(dynamicText) > -1) {
                        targetId.html(sanitizeHtmlStrings(headingHtml.replace('{prodNameLabel}',
                            '<span class="dynamic-text">' + pageTitle + '</span>')));
                    } else {
                        targetId.find('.dynamic-text').text(pageTitle);
                    }

                    if ($("textarea[data-sc-field-name='txtSubject']") && $("textarea[data-sc-field-name='txtSubject']").length > 0) {
                        $("textarea[data-sc-field-name='txtSubject']").text(pageTitle);
                    } else {
                        $("input[data-sc-field-name='txtSubject']").val(pageTitle);
                    }
                    var txtSubjectSection = $('.txtSubject_section');
                    if (txtSubjectSection !== 'undefined' && txtSubjectSection.length > 0) {
                        txtSubjectSection.text(pageTitle);
                    }
                    //pds share url
                    var shareUrl = '';
                    var linkElement = $(this).closest('.div-table-row').find('[title="File"]').eq(0);
                    if (linkElement && linkElement != 'undefined') {
                        shareUrl = $(linkElement).attr('href');
                        if ($("input[data-sc-field-name='shareDocumentUrl']") != 'undefined') {
                            $("input[data-sc-field-name='shareDocumentUrl']").val(shareUrl);
                        }
                    } else {
                        linkElement = $(this).closest('.div-table-row').find('[title="File"]').eq(2);
                        if (linkElement && linkElement != 'undefined') {
                            shareUrl = $(linkElement).attr('href');
                            if ($("input[data-sc-field-name='shareDocumentUrl']") != 'undefined') {
                                $("input[data-sc-field-name='shareDocumentUrl']").val(shareUrl);
                            }
                        }
                    }
                }
            );
        }
    });
}(window.jQuery));

 //Sitecore analytics
 analytics.eventConfig.push(
    {
        "target": ".component.sitecore-form",
        "codeId": "fo",
        "events": [
            {
                "eventTarget": "form",
                "eventType": "invalidForm",
                "tags": {
                    "componentId": "fo",
                    "componentName": "form",
                    "event": "form",
                    "elementText": "",
                    "elementType": "submit button",
                    "eventType": "form unsuccessful submit",
                    "formName": "",
                    "formTitle": "",
                    "parentName": "",
                    "parentTitle": "",
                    //merged from chemicals
                    'event1': '',
                    'eventCategory': '',
                    'eventAction': '',
                    'eventLabel': "",
                    'document_title': "",
                    'document_type': 'pdf',
                    'page_type': "",
                    'page_title': "",
                    'page_bu': "",
                    'environment': "",
                    'page_language': "",
                    'sitecore_contact_id': "",
                    'pardot_cookie_id': "",
                    'customer_type_selection': "",
                    'primary_nature_of_inquiry_selection': "",
                    'job_role_selection': "",
                    'location_selection': "",
                    'industry_selection': "",
                    'business_type_selection': "",
                    'primary_product_of_interest_selection': "",
                    'other_product_of_interest_selection': "",
                    'field_errors': "",
                    'destinationUrl' : "", 
                    "componentType": "componentForm",
                    "interactionType": "click",
                    "elementClicked": "button",
                    "contentTitle": "",
                    "deviceType": "",
                    
                }
            },
            {
                "eventTarget": "OnFormSuccessfulSubmit",
                "eventType": "submit",
                "tags": {
                    "componentId": "fo",
                    "componentName": "form",
                    "event": "form",
                    "elementText": "",
                    "elementType": "form confirmation",
                    "eventType": "form successful submit",
                    "formName": "",
                    "formTitle": "",
                    "formDropdowns": "",
                    "parentName": "",
                    "parentTitle": "",
                    //merged from chemicals
                    'event1': '',
                    'eventCategory': "",
                    "componentType": "componentForm",
                    "interactionType": "click",
                    "elementClicked": "button",
                    "contentTitle": "",
                    "deviceType": "",
                    'eventAction': '',
                    'eventLabel': "",
                    'document_title': "",
                    'document_type': 'pdf',
                    'page_type': "",
                    'page_title': "",
                    'page_bu': "",
                    'environment': "",
                    'page_language': "",
                    'destinationUrl' : "",   
                    'sitecore_contact_id': "",
                    'pardot_cookie_id': "",
                    'customer_type_selection': "",
                    'primary_nature_of_inquiry_selection': "",
                    'job_role_selection': "",
                    'location_selection': "",
                    'industry_selection': "",
                    'business_type_selection': "",
                    'primary_product_of_interest_selection': "",
                    'other_product_of_interest_selection': "",

                }
            },
            {
                "eventTarget": "form",
                "eventType": "formInit",
                "tags": {
                    "componentId": "fo",
                    "componentName": "form",
                    "elementText": "",
                    "elementType": [
                        {
                            "rule": "$('[data-bs-target=" + "\"#" + "' + $(context).parents('.modal').attr('id') + '" + "\"" + "]').hasClass('btn')",
                            "value": "lightbox button"
                        },
                        {
                            "rule": "true",
                            "value": "lightbox link"
                        }
                    ],
                    "event": "form",
                    "eventType": "form initiation",
                    "formName": "",
                    "formTitle": "",
                    "parentName": "",
                    "parentTitle": "",
                    //merged from chemicals
                    'event1': '',
                    'eventCategory': '',
                    'eventAction': 'Email Product Data Sheet',
                    'eventLabel': "",
                    'document_title': "",
                    'document_type': 'pdf',
                    'page_type': "",
                    'page_title': "",
                    'page_bu': "",
                    'environment': "",
                    'page_language': "",
                    'sitecore_contact_id': "",
                    'pardot_cookie_id': "",
                    'customer_type_selection': "",
                    'primary_nature_of_inquiry_selection': "",
                    'job_role_selection': "",
                    'location_selection': "",
                    'industry_selection': "",
                    'business_type_selection': "",
                    'primary_product_of_interest_selection': "",
                    'other_product_of_interest_selection': "",

                    //merged from chemicals
                }
            },
            {
                "eventTarget": "form",
                "eventType": "formCancel",
                "tags": {
                    "componentId": "fo",
                    "componentName": "form",
                    "elementText": "cancel",
                    "elementType": "cancel button",
                    "event": "form",
                    "eventType": "form cancel click",
                    "formName": "",
                    "formTitle": "",
                    "parentName": "",
                    "parentTitle": "",
                    //merged from chemicals
                    'event1': '',
                    'eventCategory': '',

                    'eventAction': 'Email Product Data Sheet',
                    'eventLabel': "",
                    'document_title': "",
                    'document_type': 'pdf',
                    'page_type': "",
                    'page_title': "",
                    'page_bu': "",
                    'environment': "",
                    'page_language': "",
                    'sitecore_contact_id': "",
                    'pardot_cookie_id': "",
                    'customer_type_selection': "",
                    'primary_nature_of_inquiry_selection': "",
                    'job_role_selection': "",
                    'location_selection': "",
                    'industry_selection': "",
                    'business_type_selection': "",
                    'primary_product_of_interest_selection': "",
                    'other_product_of_interest_selection': "",

                    //merged from chemicals
                }
            },

        ]
    },
)